import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { tariffsApi } from '../client';
import type { BuyTemplate, BuyTemplateCreateRequest, BuyTemplateUpdateRequest } from '../types';

export const buyTemplatesAdapter: CrudAdapter<
  BuyTemplate,
  BuyTemplateCreateRequest,
  BuyTemplateUpdateRequest
> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await tariffsApi.GET('/buy-templates/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'desc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async byKey(id) {
    const { data, error } = await tariffsApi.GET('/buy-templates/{template_id}', {
      params: { path: { template_id: Number(id) } },
    });
    if (error) throw error;
    return data as BuyTemplate;
  },
  async create(payload) {
    const { data, error } = await tariffsApi.POST('/buy-templates/', { body: payload });
    if (error) throw error;
    return { id: data?.buy_template_id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await tariffsApi.PUT('/buy-templates/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as unknown as BuyTemplate;
  },
  async remove(id) {
    const { error } = await tariffsApi.DELETE('/buy-templates/{template_id}', {
      params: { path: { template_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const buyTemplatesStore = useCrudDataSource(buyTemplatesAdapter);
